<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>回单登记使用说明:<br>
					<span>1、由调度单生成,也可以手动录入</span><br>
					<span>2、状态:只有提交状态才算完成</span><br>
					<span>3、查询关键字:单号、经办人</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

		</pre-base>

	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '回单费用记录',
					"control": "transback",
					"isTwo": "1",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_ys_transback_m',
					"upd_action": 'exp15_ys_transback_m',
					"detail_part": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": 'transback',
					"p1": 'wddj',
					"p2": 'transback',
					"p3": '',
					"parm_sel": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "押金人",
							"val": "",
							"key": "u_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_id",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_roleuser",
							"sel_name": "",
							"sel": "1"
						}
					],
					"parm": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "押金",
							"val": "500",
							"key": "amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},	
						{
							"name": "押金人",
							"val": "",
							"key": "ya_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},	
						{
							"name": "押金人电话",
							"val": "",
							"key": "ya_phone",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},	
						{
							"name": "装货地点",
							"val": "",
							"key": "item_up_addr",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "2"
						},	
						{
							"name": "卸货地点",
							"val": "",
							"key": "item_down_addr",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "2"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "2"
						},
						{
							"name": "车挂",
							"val": "",
							"key": "car_gua",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "2"
						},
						{
							"name": "司机",
							"val": "",
							"key": "driver",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "2"
						},
						{
							"name": "司机电话",
							"val": "",
							"key": "phone",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "2"
						},
						{
							"name": "回单状态",
							"val": "",
							"key": "check_flag",
							"type": "radio",
							"class": "long1",
							"list":[{"id":"1","val":"待办"},{"id":"2","val":"完成"}],
							"sel_action": "",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_id",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_roleuser",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
											
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "装货地点"
						},
						{
							"name": "卸货地点"
						},
						{
							"name": "车牌"
						},
						{
							"name": "车挂"
						},
						{
							"name": "司机"
						},
						{
							"name": "司机电话"
						},
						{
							"name": "金额"
						},
						{
							"name": "押金人"
						},
						{
							"name": "押金人电话"
						},
						{
							"name": "回单状态"
						},
						{
							"name": "经办人"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						{
							"name": "状态",
							"class": "short0"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						},
						{
							"name": "修改时间",
							"class": "long2"
						}
					],
					"d_parm": [],
					"d_name": []

				});
			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style scoped>


</style>
